import React from "react";
import { makeStyles, useTheme, useMediaQuery } from "@material-ui/core";

import CardDownload from "./cardDownload";
import Carousel from "react-elastic-carousel";

let useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    flexDirection: "column",
    ...theme.grid.gridMdContent,
    width: "100%",
    maxWidth: "100%",
  },
  line: {
    borderRadius: 3,
    height: 4,
    border: "none",
    backgroundColor: theme.palette.light.type2,
    position: "absolute",
    top: -10,
    width: 30,
    right: "50%",
  },
  gridTitle: {
    position: "relative",
    marginTop: 100,
  },
  title: {
    fontSize: 28,
    marginBottom: 75,
    "@media (max-width:445px)": {
      textAlign: "center",
    },
  },
  gridDownload: {
    width: "35%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-around",
    flexWrap: "wrap",
    minWidth: 1150,
    "@media (max-width:1210px)": {
      minWidth: "95%",
      margin: "auto",
    },
    "@media (max-width:750px)": {
      textAlign: "center",
      justifyContent: "center",
      flexDirection: "column",
      minWidth: "100%",
    },
  },
  mobileWrap: {
    width: "100%",
    padding: "0 16px",
    marginTop: 40,
    display: "none",
    [theme.breakpoints.down("sm")]: {
      display: "block",
    },
  },
  mobileTitle: {
    textAlign: "center",
    fontSize: 20,
    fontWeight: 600,
    marginBottom: 20,
  },
  carouselWrap: {
    "& .rec-carousel": {
      maxWidth: "100%",
    },
    "& .rec-slide": {
      display: "flex",
      justifyContent: "center",
    },
  },
}));

export default function Index() {
  let classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  let data = [
    {
      title: "آموزش رایان همراه",
      link: "/assets/file/system/آموزش رایان همراه.pdf",
    },
    {
      title: "راهنمای آنلاین اکسیر",
      link: "/assets/file/system/راهنمای آنلاین اکسیر.pdf",
    },
    {
      title: "راهنمای آنلاین قدیمی",
      link: "/assets/file/system/راهنمای آنلاین قدیمی.pdf",
    },
    {
      title: "راهنمای همراه پلاس",
      link: "/assets/file/system/rahnama-hamrah.pdf",
    },
    {
      title: "راهنمای آنلاین پلاس",
      link: "/assets/file/system/rahnama-online.pdf",
    },
    { title: "راهنمای کمان", link: "/assets/file/system/راهنمای کمان.pdf" },
    {
      title: "راهنمای نحوه انجام معاملات اوراق اختیار معامله (آپشن)",
      link: "/assets/file/system/نحوه انجام معامالت اوراق اختیار معامله (آپشن).pdf",
    },
    {
      title: "راهنمای سامانه آتی",
      link: "/assets/file/system/راهنمای سامانه آتی.pdf",
    },
  ];

  return (
    <div className={classes.root}>
      <div className={classes.gridTitle}>
        <div className={classes.line} />
        <h3 className={classes.title}>دانلود فایل های آموزشی</h3>
      </div>

      {/* دسکتاپ: گرید اصلی */}
      {!isMobile && (
        <div className={classes.gridDownload}>
          {data.map((item, index) => (
            <CardDownload data={item} key={index} />
          ))}
        </div>
      )}

      {/* موبایل: Carousel */}
      {isMobile && (
        <div className={classes.mobileWrap}>
          <div className={classes.carouselWrap}>
            <Carousel
              breakPoints={[{ width: 1, itemsToShow: 1 }]}
              enableAutoPlay
              autoPlaySpeed={3000}
              renderArrow={() => <span style={{ display: "none" }} />}
              renderPagination={() => <span style={{ display: "none" }} />}
              isRTL
            >
              {data.map((item, index) => (
                <div key={"dl-" + index}>
                  <CardDownload data={item} />
                </div>
              ))}
            </Carousel>
          </div>
        </div>
      )}
    </div>
  );
}
